import "moment/locale/ar";
import "moment/locale/en-gb";
import { AGENCY } from "./agency";
import theme from "./theme";

const apiBaseURL = () => {
  return process.env.NODE_ENV === "development"
    ? "https://dev-zd.propone.pk/api"
    : `${window.origin}/api`
}

const agenciesConfig = {
  zd:{
    agencyName: "Zameen",
    apiBaseURL,
    countryCode: "PK",
    currency: "PKR",
    countryId: 155,
    timezone: "Asia/Karachi",
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        locale: "en",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
  },
  bayut:{
    agencyName: "bayut",
    apiBaseURL,//
    countryCode: "PK",
    currency: "PKR",
    countryId: 155,
    timezone: "Asia/Karachi",
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        locale: "en",
        locale_full: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
      {
        id: 2,
        key: "ar",
        label: "AR",
        locale: "ar",
        locale_full: "ar-SA",
        rtl: true,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;700&display=swap",
      },
    ],
  }
}
const configs = agenciesConfig[AGENCY]
export { configs, theme };

